<template>
  <div
    class="
      push-notification-main-wrapper
      cbg-white-container
      input-container
      theme--light
      v-card
    "
  >
    <div>
      <v-tabs
        v-model="tabs"
        background-color="transparent"
        class="border-bottom"
      >
        <v-tab v-for="item in items" :key="item">{{ item.tabName }}</v-tab>
        <!-- <v-tab>Sent Messages</v-tab> -->
      </v-tabs>

      <v-tabs-items v-model="tabs">
        <!-- .......... new message ......... -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <doctor-subscriptions-via-docsmart v-if="tabs == 0" />
            </v-card-text>
          </v-card>
        </v-tab-item>
        <!-- .......... end new message ......... -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <center-subscriptions-via-docsmart v-if="tabs == 1" />
            </v-card-text>
          </v-card>
        </v-tab-item>
        <!-- .......... end sent messages ......... -->
      </v-tabs-items>
    </div>
  </div>
</template>
  
  <script>
import "@/assets/scss/_systemNotifications.scss";
import { pickSvg } from "@/views/SVG";
const doctorSubscriptionsViaDocsmart = () =>
  import("@/views/seva/DoctorSubscriptionsViaDocSmart");
const CenterSubscriptionsViaDocSmart = () =>
  import("@/views/seva/CenterSubscriptionsViaDocSmart");
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      permissions: "getPermissions",
    }),
  },
  data() {
    return {
      tabs: null,
      items: [{ tabName: "Doctor" }, { tabName: "Centers" }],
    };
  },

  components: {
    ...pickSvg("filterSVG"),
    "doctor-subscriptions-via-docsmart": doctorSubscriptionsViaDocsmart,
    "center-subscriptions-via-docsmart": CenterSubscriptionsViaDocSmart,
  },
};
</script>